import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://ticobaterias.com/api';

export default function Dashboard() {
  const [stats, setStats] = useState({ productos:0, categorias:0, cotizaciones:0, resenas:0 });
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/productos/`),
      axios.get(`${API}/categorias/`),
      axios.get(`${API}/cotizaciones/`, { headers }),
      axios.get(`${API}/resenas/admin`, { headers }),
    ]).then(([p, c, cot, r]) => {
      setStats({ productos: p.data.length, categorias: c.data.length, cotizaciones: cot.data.length, resenas: r.data.length });
    }).catch(() => {});
  }, []);

  const cards = [
    { icon:'🔋', label:'Productos', val: stats.productos, color:'bg-azul', path:'/productos' },
    { icon:'🏷️', label:'Categorías', val: stats.categorias, color:'bg-azul-light', path:'/categorias' },
    { icon:'💬', label:'Cotizaciones', val: stats.cotizaciones, color:'bg-rojo', path:'/cotizaciones' },
    { icon:'⭐', label:'Reseñas', val: stats.resenas, color:'bg-yellow-500', path:'/resenas' },
  ];

  return (
    <div>
      <h1 className="font-bold text-2xl text-azul mb-2">Dashboard</h1>
      <p className="text-gray-500 text-sm mb-8">Resumen general del sitio</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-8">
        {cards.map(c => (
          <div key={c.label} className={`${c.color} rounded-2xl p-6 text-white`}>
            <div className="text-3xl mb-3">{c.icon}</div>
            <div className="text-3xl font-black mb-1">{c.val}</div>
            <div className="text-white/70 text-sm font-medium">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-2xl p-6 border border-gray-100">
        <h2 className="font-bold text-lg text-azul mb-4">Accesos rápidos</h2>
        <div className="grid md:grid-cols-3 gap-4">
          {[
            {icon:'🔋', label:'Agregar producto', path:'/productos'},
            {icon:'💬', label:'Ver cotizaciones', path:'/cotizaciones'},
            {icon:'⭐', label:'Moderar reseñas', path:'/resenas'},
          ].map(item => (
            <a key={item.path} href={item.path}
              className="flex items-center gap-3 p-4 border border-gray-200 rounded-xl hover:border-azul hover:bg-azul/5 transition-all">
              <span className="text-2xl">{item.icon}</span>
              <span className="font-medium text-gray-700 text-sm">{item.label}</span>
              <span className="ml-auto text-gray-400">→</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
